import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface LwHubCardProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'name'> {
  name: ReactNode;
  description: ReactNode;
  icon?: ReactNode;
  stat?: ReactNode;
  statCaption?: ReactNode;
  frequency?: ReactNode;
  warning?: ReactNode;
}

/** Callback-driven navigation card for the portal's id-based sections. */
export function LwHubCard({
  name,
  description,
  icon,
  stat,
  statCaption,
  frequency,
  warning,
  className,
  type = 'button',
  ...rest
}: LwHubCardProps) {
  const hasStat = stat !== null && stat !== undefined && stat !== false;
  const hasStatCaption = statCaption !== null && statCaption !== undefined && statCaption !== false;
  const hasWarning = warning !== null && warning !== undefined && warning !== false;

  return (
    <button className={`lw-hub-card${className ? ` ${className}` : ''}`} type={type} {...rest}>
      <span className="lw-hub-card__top">
        {icon && <span className="lw-hub-card__icon" aria-hidden="true">{icon}</span>}
        {frequency && <span className="lw-hub-card__frequency">{frequency}</span>}
      </span>
      <strong>{name}</strong>
      <span className="lw-hub-card__description">{description}</span>
      {(hasStat || hasWarning) && (
        <span className="lw-hub-card__foot">
          {hasStat && <span><b>{stat}</b>{hasStatCaption && <small>{statCaption}</small>}</span>}
          {hasWarning && <span className="lw-hub-card__warning">{warning}</span>}
        </span>
      )}
    </button>
  );
}
